// frontend/src/hooks/useGLAccounts.js
import { useState, useEffect } from 'react';
import axios from 'axios';

export const useGLAccounts = () => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/finance/gl-accounts`,
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        setAccounts(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  return { accounts, loading };
};